export const fmtMs = (n) => `${Math.round(Number(n || 0))}ms`;
export const fmtPct01 = (n) => `${Math.round(Number(n || 0) * 1000) / 10}%`;
export const fmtNum = (n) =>
  Number.isFinite(Number(n)) ? Math.round(Number(n) * 100) / 100 : 0;

export const fmtBytes = (b) => {
  const n = Number(b || 0);
  if (!Number.isFinite(n) || n <= 0) return "0 B";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024;
    i++;
  }
  return `${Math.round(v * 100) / 100} ${u[i]}`;
};
